var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurvyline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 136,
    viewBox: "0 0 209 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1206 123.33C21.15 111.467 29.2209 99.2891 42.4303 98.354C52.5411 97.6383 62.9776 103.508 70.56 109.311C71.8113 110.269 81.8483 118.488 75.3265 120.42C63.4011 123.952 54.524 114.789 51.6141 104.061C47.2905 88.1207 53.1576 72.4087 65.0377 61.2422C79.7752 47.3899 105.036 34.8978 124.767 44.8376C133.967 49.4726 138.459 55.7632 141.038 65.4841C143.092 73.2229 144.179 82.9083 137.65 89.2134C126.906 99.5899 114.123 89.3911 108.523 79.1142C97.1756 58.2897 106.149 29.3255 127.082 18.4083C145.444 8.8324 166.639 5.57618 187.067 4.3078",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvyline);
export default __webpack_public_path__ + "static/media/curvyline.28caa8c6cd32bc8cbf3dd7f18c2c46ba.svg";
export { ForwardRef as ReactComponent };